/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Cancellation_NoticeInputs */

const en_admin_resources_cancellation_notice = /** @type {(inputs: Admin_Resources_Cancellation_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation notice`)
};

const de_admin_resources_cancellation_notice = /** @type {(inputs: Admin_Resources_Cancellation_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kündigungsfrist`)
};

const es_admin_resources_cancellation_notice = /** @type {(inputs: Admin_Resources_Cancellation_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de cancelación`)
};

const fr_admin_resources_cancellation_notice = /** @type {(inputs: Admin_Resources_Cancellation_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avis d'annulation`)
};

/** @type {(inputs: Admin_Resources_Cancellation_NoticeInputs) => LocalizedString} */
const it_admin_resources_cancellation_notice = en_admin_resources_cancellation_notice;

/** @type {(inputs: Admin_Resources_Cancellation_NoticeInputs) => LocalizedString} */
const pt_br2_admin_resources_cancellation_notice = en_admin_resources_cancellation_notice;

/** @type {(inputs: Admin_Resources_Cancellation_NoticeInputs) => LocalizedString} */
const pl_admin_resources_cancellation_notice = en_admin_resources_cancellation_notice;

/** @type {(inputs: Admin_Resources_Cancellation_NoticeInputs) => LocalizedString} */
const hu_admin_resources_cancellation_notice = en_admin_resources_cancellation_notice;

/** @type {(inputs: Admin_Resources_Cancellation_NoticeInputs) => LocalizedString} */
const ro_admin_resources_cancellation_notice = en_admin_resources_cancellation_notice;

/**
* | output |
* | --- |
* | "Cancellation notice" |
*
* @param {Admin_Resources_Cancellation_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_cancellation_notice = /** @type {((inputs?: Admin_Resources_Cancellation_NoticeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Cancellation_NoticeInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_cancellation_notice(inputs)
	if (locale === "de") return de_admin_resources_cancellation_notice(inputs)
	if (locale === "es") return es_admin_resources_cancellation_notice(inputs)
	if (locale === "fr") return fr_admin_resources_cancellation_notice(inputs)
	if (locale === "it") return it_admin_resources_cancellation_notice(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_cancellation_notice(inputs)
	if (locale === "pl") return pl_admin_resources_cancellation_notice(inputs)
	if (locale === "hu") return hu_admin_resources_cancellation_notice(inputs)
	return ro_admin_resources_cancellation_notice(inputs)
});
export { admin_resources_cancellation_notice as "admin.resources.cancellation_notice" }